var AppIntervals = /* @__PURE__ */ ((AppIntervals2) => {
  AppIntervals2[AppIntervals2["liveEVents"] = 1e3] = "liveEVents";
  AppIntervals2[AppIntervals2["heartBeatRequest"] = 5e3] = "heartBeatRequest";
  AppIntervals2[AppIntervals2["couponRefresh"] = 1e3] = "couponRefresh";
  AppIntervals2[AppIntervals2["lineEvents"] = 2e4] = "lineEvents";
  AppIntervals2[AppIntervals2["updateMenu"] = 15e3] = "updateMenu";
  AppIntervals2[AppIntervals2["updateMenuTopEvents"] = 5e4] = "updateMenuTopEvents";
  AppIntervals2[AppIntervals2["userDataUpdate"] = 3e4] = "userDataUpdate";
  AppIntervals2[AppIntervals2["userRefresh"] = 3e4] = "userRefresh";
  AppIntervals2[AppIntervals2["boLiveEventsAndWeather"] = 3e4] = "boLiveEventsAndWeather";
  AppIntervals2[AppIntervals2["sliderUpdate"] = 1e4] = "sliderUpdate";
  AppIntervals2[AppIntervals2["alive"] = 8e3] = "alive";
  AppIntervals2[AppIntervals2["checkBalance"] = 5e3] = "checkBalance";
  AppIntervals2[AppIntervals2["checkBonuses"] = 5e3] = "checkBonuses";
  AppIntervals2[AppIntervals2["betInterval"] = 2e4] = "betInterval";
  AppIntervals2[AppIntervals2["casinoWinners"] = 1e4] = "casinoWinners";
  AppIntervals2[AppIntervals2["hofSportTopWinners"] = 3e5] = "hofSportTopWinners";
  AppIntervals2[AppIntervals2["hofCasinotTopWinners"] = 3e5] = "hofCasinotTopWinners";
  AppIntervals2[AppIntervals2["mainBanner"] = 5e3] = "mainBanner";
  AppIntervals2[AppIntervals2["betTournamentWidget"] = 3e4] = "betTournamentWidget";
  AppIntervals2[AppIntervals2["betTournamentPage"] = 3e4] = "betTournamentPage";
  AppIntervals2[AppIntervals2["swiperBoxNextSlide"] = 12e3] = "swiperBoxNextSlide";
  AppIntervals2[AppIntervals2["swiperToAutoHeight"] = 150] = "swiperToAutoHeight";
  AppIntervals2[AppIntervals2["dashboardData"] = 6e4] = "dashboardData";
  AppIntervals2[AppIntervals2["locationDevice"] = 6e4] = "locationDevice";
  AppIntervals2[AppIntervals2["locationDeviceRetry"] = 7e3] = "locationDeviceRetry";
  AppIntervals2[AppIntervals2["userActivity"] = 5e3] = "userActivity";
  AppIntervals2[AppIntervals2["cashierWithdrawals"] = 5e3] = "cashierWithdrawals";
  AppIntervals2[AppIntervals2["liveEventsQuantityDesktop"] = 12e4] = "liveEventsQuantityDesktop";
  AppIntervals2[AppIntervals2["menuLiveDesktop"] = 6e4] = "menuLiveDesktop";
  AppIntervals2[AppIntervals2["menuLiveMobile"] = 6e4] = "menuLiveMobile";
  AppIntervals2[AppIntervals2["menuLineDesktop"] = 6e4] = "menuLineDesktop";
  AppIntervals2[AppIntervals2["menuLineMobile"] = 6e4] = "menuLineMobile";
  AppIntervals2[AppIntervals2["liveTopEventsDesktop"] = 24e4] = "liveTopEventsDesktop";
  AppIntervals2[AppIntervals2["lineTopEventsDesktop"] = 24e4] = "lineTopEventsDesktop";
  AppIntervals2[AppIntervals2["favoriteEventsMobile"] = 24e4] = "favoriteEventsMobile";
  AppIntervals2[AppIntervals2["favoriteEventsDesktop"] = 24e4] = "favoriteEventsDesktop";
  AppIntervals2[AppIntervals2["liveSportEventsDesktop"] = 6e4] = "liveSportEventsDesktop";
  AppIntervals2[AppIntervals2["lineSportEventsDesktop"] = 6e4] = "lineSportEventsDesktop";
  AppIntervals2[AppIntervals2["liveSportEventsMobile"] = 6e4] = "liveSportEventsMobile";
  AppIntervals2[AppIntervals2["lineSportEventsMobile"] = 6e4] = "lineSportEventsMobile";
  AppIntervals2[AppIntervals2["liveSportEventsMobileIvi"] = 6e4] = "liveSportEventsMobileIvi";
  AppIntervals2[AppIntervals2["lineSportEventsMobileIvi"] = 6e4] = "lineSportEventsMobileIvi";
  AppIntervals2[AppIntervals2["cashierSuccess"] = 5e3] = "cashierSuccess";
  return AppIntervals2;
})(AppIntervals || {});
var FormElementsDebounce = /* @__PURE__ */ ((FormElementsDebounce2) => {
  FormElementsDebounce2[FormElementsDebounce2["elements"] = 300] = "elements";
  FormElementsDebounce2[FormElementsDebounce2["wrapper"] = 200] = "wrapper";
  return FormElementsDebounce2;
})(FormElementsDebounce || {});
export {
  AppIntervals,
  FormElementsDebounce
};
